// Filtro de fecha por defecto (45 días atrás / 45 adelante) para que el
// listado/kanban no se sature con OT completadas hace mucho ni con OT
// programadas muy a futuro. Se recalcula cada vez que se aplica (carga
// inicial y "Limpiar filtros" — ver RESET_FILTROS en mutations.js), no una
// vez fija al cargar el módulo.
const DIA_SEGUNDOS = 86400
const RANGO_FECHA_DEFECTO_DIAS = 45

export function rangoFechaDefecto() {
  const ahora = Math.floor(Date.now() / 1000)

  return {
    fecha_desde: ahora - RANGO_FECHA_DEFECTO_DIAS * DIA_SEGUNDOS,
    fecha_hasta: ahora + RANGO_FECHA_DEFECTO_DIAS * DIA_SEGUNDOS
  }
}

export default {
  items: [],                 // listado plano — la tabla lo pagina, el kanban lo agrupa localmente
  pagination: { page: 1, perPage: 20, total: 0, lastPage: 1 },
  filtros: {
    area: null,
    estado: null,
    prioridad: null,
    responsable_id: null,
    solicitante_id: null,
    cliente_id: null,
    ticket_id: null,
    cotizacion_id: null,
    search: '',
    ...rangoFechaDefecto(),
    solo_vencidas: false,
    archivado: false
  },
  vista: 'kanban',            // 'kanban' | 'tabla'
  loading: false,

  detalle: null,               // OT completa (checklists/mensajes/participantes/suscripciones) cuando el drawer está abierto
  detalleLoading: false,

  usuariosAsignables: [],

  areas: [],                   // departamentos activos del catálogo ({ codigo, nombre, tiene_encargado })

  checklistPlantillas: []
}
